import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_COLLAB_SIDEBAR_HANDLER = {
  topic: TOPIC_NAMES.OPEN_COLLAB_SIDEBAR,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/CollabSidebar')
};